namespace $.$$ {

	$mol_style_define( $shm_opencode_app, {
		Provider_label: {
			width: '100%',
		},
		Custom_provider_content: {
			gap: $mol_gap.block,
		},
	} )

}
